module.exports = __webpack_public_path__ + "static/Illustration-bb9ca8d5df955011e3114a0a21fa05b5.svg";